import { Badge, Group, Text } from "@mantine/core";
import { FiltroIdeia } from "./ModalFilterIdeias";

interface FiltrosAtivosProperties {
  filtros: FiltroIdeia;
  totalResultados?: number;
}

const FiltrosAtivos = ({ filtros, totalResultados }: FiltrosAtivosProperties) => {
  const filtrosAtivos: string[] = [];

  // Verificar filtros ativos
  if (filtros.status) {
    const statusLabels: Record<string, string> = {
      NOVA_IDEIA: "Nova Ideia",
      AGUARDANDO_ANALISE_DO_COMITE: "Aguardando Análise do Comitê",
      PRE_ANALISE: "Pré-análise",
      EM_ANALISE_DE_VIABILIDADE: "Em Análise de Viabilidade",
      RASCUNHO: "Rascunho",
      APROVADA: "Aprovada",
      REPROVADA: "Reprovada",
      IMPLEMENTADA: "Implementada",
      CANCELADA: "Cancelada",
      EM_IMPLEMENTACAO: "Em Implementação",
      BACKLOG_DE_AVALIACAO_FUTURA: "Backlog de Avaliação Futura"
    };
    filtrosAtivos.push(`Status: ${statusLabels[filtros.status] || filtros.status}`);
  }

  if (filtros.search && filtros.campo) {
    filtrosAtivos.push(`${filtros.campo}: "${filtros.search}"`);
  }

  if (filtrosAtivos.length === 0) {
    return (
      <Group gap="xs">
        <Text size="sm" c="dimmed">
          Nenhum filtro aplicado
        </Text>
      </Group>
    );
  }

  return (
    <Group gap="xs">
      <Text size="sm" c="dimmed">
        Filtros ativos:
      </Text>
      {filtrosAtivos.map((filtro, index) => (
        <Badge key={index} variant="light" size="sm">
          {filtro}
        </Badge>
      ))}
      {totalResultados !== undefined && (
        <Text size="sm" c="dimmed">
          • {totalResultados} resultado{totalResultados === 1 ? "" : "s"} encontrado{totalResultados === 1 ? "" : "s"}
        </Text>
      )}
    </Group>
  );
};

export default FiltrosAtivos;
